import { render, staticRenderFns } from "./CustomScoringCode.vue?vue&type=template&id=c2d6ea0c&"
import script from "./CustomScoringCode.js?vue&type=script&lang=js&"
export * from "./CustomScoringCode.js?vue&type=script&lang=js&"
import style0 from "./CustomScoringCode.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VLabel,VList,VListGroup,VListItem,VListItemContent,VListItemTitle,VTextField})
